import { Autocomplete, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getTraitListing } from "../../../redux/slices/traitSlice";
import { deleteProductUnit, getSubTraitListing, getUnitListing } from "../../../redux/slices/subtraitSlice";
import { closeCustomModalDialog, openCustomModalDialog, setModalLoader } from "../../../redux/slices/modalSlice";
import MDButton from "components/MDButton";
import DeleteIcon from "common/customIcons/delete";
import { openSnackbar } from "../../../redux/slices/common";
import { useParams } from "react-router-dom";
import { createProductTrait, getProductTraitDetail, getSubTraitForMain, updateProductTrait } from "../../../redux/slices/products";
import { subTraitValidation } from "validations/subTraits";
import { useSelector } from "react-redux";
import { ClearIcon } from "@mui/x-date-pickers";
import { HEMP,STILO } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export default function SelectProductTrait({ handleCancel, searchFn, closeForm, productTraitId }) {
  const dispatch = useDispatch();
  const { productId = '' } = useParams();
  const { loadingProductTraits } = useSelector(state => state.products || {});
  const [formData, setFormData] = useState({
    mainTraitName: "",
    subTraitName: "",
    value: "",
    unit: "",
  });

  const [mainTraits, setMainTraits] = useState([]);
  const [subtraits, setSubTraits] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [selectedMainTraitId, setSelectedMainTraitId] = useState("")
  const [errors, setErrors] = useState(false);
  const [fetchUnitData, setFetchUnitData] = useState(false)
  const [shouldFetchAfterDelete, setShouldFetchAfterDelete] = useState(false);
  const [shouldFetchAfterAdd, setShouldFetchAfterAdd] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };


  useEffect(() => {
    const fetchproductTraitDetails = async () => {
      try {
        if (!productTraitId) return;
        const traitDetailResponse = await dispatch(getProductTraitDetail({ productId, traitId: productTraitId })).unwrap()
        setFormData({ ...traitDetailResponse.traitDetails })

      } catch (error) {
      }
    };
    fetchproductTraitDetails()
  }, [productId, productTraitId, dispatch]);

  useEffect(() => {
    const fetchParentTraits = async () => {
      try {
        const parentTraitsResponse = await dispatch(getTraitListing({ platformType: adminsMode === STILO ?'stilo':'hemp', skip: 0, limit: 100 })).unwrap();
        setMainTraits(parentTraitsResponse.traits);
      } catch (error) {
      }
    };

    fetchParentTraits();
  }, []);

  useEffect(() => {
    const fetchSubTraits = async () => {
      try {
        const subtraitsResponse = await dispatch(getSubTraitForMain({ traitId: selectedMainTraitId, platformType:adminsMode === STILO ?'stilo': 'hemp', skip: 0, limit: 100 })).unwrap();
        setSubTraits(subtraitsResponse.subTraits);
      } catch (error) {
      }
    };

    fetchSubTraits();
  }, [selectedMainTraitId, dispatch]);

  useEffect(() => {
    const fetchUnitListing = async () => {
      try {
        const unitResponse = await dispatch(getUnitListing()).unwrap();
        setUnitList(unitResponse?.units)
      } catch (error) {
      }
    };
    fetchUnitListing()
    setShouldFetchAfterDelete(false)
    setFetchUnitData(false)
  }, [fetchUnitData, shouldFetchAfterDelete])

  const fetchUnitListingData = () => {
    setFetchUnitData(true)
  }

  const handleAddNewUnitModal = () => {
    dispatch(openCustomModalDialog({ modal: 'ADD_NEW_UNIT_MODAL', modalData: { fetchUnitListingData, formData, setFormData } }))
  }


  const showError = (message, errorType) => {
    if (errorType === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errorType === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };

  const deleteHandler = (deleteId) => {
    dispatch(setModalLoader(true));
    dispatch(deleteProductUnit(deleteId)).unwrap().then((res) => {
      showError(res?.message, 'success');
      dispatch(closeCustomModalDialog());
      setShouldFetchAfterDelete(true)
    }).catch((err) => {
      dispatch(setModalLoader(false))
      showError(err?.message, 'error')
    })
  }


  const handleSave = async (e) => {
    e.preventDefault();
    const { isValid, errors } = subTraitValidation(formData);
    if (!isValid) {
      setErrors(errors);
      return;
    }
    try {
      const mergedValue = `${formData.value} ${formData.unit}`;
      // Prepare the data object with the merged value
      const data = {
        productId: productId,
        productTraits: [
          {
            ...formData,
            valueAndUnit: mergedValue, // Add merged value and unit
          },
        ],
      };
      // const data = { productId: productId, productTraits: [formData] };
      if (productTraitId) {
        await dispatch(updateProductTrait(data)).unwrap().then(res => {
          showError(res.message, 'success');
          closeForm();
          searchFn();
        })
      }
      else {
        await dispatch(createProductTrait(data)).unwrap()
          .then(res => {
            showError(res.message, 'success');
            closeForm();
            searchFn();
          })
          .catch(res => {
            // Check if error has a message field, and display it, otherwise show a default error message
            showError(res.message, 'error');
          });
      }
      
    } catch (error) {
      showError("Failed to save product trait", 'error');
    }
  }


  return (
    <>
      <div className="py-5 bg-grey mt-3">
        <Grid container spacing={2} className="py-4">
        <Grid item xs={12} sm={6} md={3} lg={3}>
  <Autocomplete
    id="tags-outlined"
    options={mainTraits?.length > 0 ? mainTraits : []} // Use mainTraits for options
    getOptionLabel={(option) => option?.mainTraitName}
    value={
      mainTraits.find(
        (mainTrait) => mainTrait.mainTraitName === formData.mainTraitName
      ) || null
    }
    onChange={(event, selectedOption) => {
      setFormData({
        ...formData,
        mainTraitName: selectedOption?.mainTraitName,
      }); // Update mainTraitName in formData
      setSelectedMainTraitId(selectedOption?._id)
    }}
    isOptionEqualToValue={(option, value) =>
      option.mainTraitName === value.mainTraitName
    }
    disabled={
      formData.subTraitName && // Check if subTraitName exists
      subtraits.some(
        (sub) =>
          sub.subTraitName === formData.subTraitName && sub.mainTraitName === null
      ) // Check if mainTraitName is null for the subTraitName
    }
    renderInput={(params) => (
      <TextField
        {...params}
        label="Major Trait"
        error={Boolean(errors?.mainTraitName)} // Optional error handling
        helperText={errors?.mainTraitName}
        style={{
          opacity:
            formData.subTraitName &&
            subtraits.some(
              (sub) => sub.subTraitName === formData.subTraitName && sub.mainTraitName === null
            )
              ? 0.6
              : 1, // Adjust opacity if the condition is met
        }}
        InputProps={{
          ...params.InputProps,
          endAdornment: formData.mainTraitName && (
            <IconButton
              onClick={() => {
                // Clear the mainTraitName and selectedMainTraitId when the cross is clicked
                setFormData({ ...formData, mainTraitName: '' });
                setSelectedMainTraitId(''); // Clear the selectedMainTraitId as well
              }}
              edge="end"
              size="small"
            >
              <ClearIcon />
            </IconButton>
          ),
        }}
      />
    )}
  />
</Grid>

          <Grid item xs={12} sm={6} md={3} lg={3} >
            <Autocomplete
              id="tags-outlined"
              options={
                subtraits?.length > 0 ? subtraits?.filter((item) => item?.status === "Active") : []
              }
              getOptionLabel={(option) => option?.subTraitName}
              filterSelectedOptions
              value={
                subtraits.find(
                  (sub) => sub.subTraitName === formData.subTraitName
                ) || null
              }
              onChange={(event, selectedOption) => {
                setSelectedOption(selectedOption);  // Update the selectedOption state when a user selects an option
                setFormData({ ...formData, subTraitName: selectedOption?.subTraitName, listImage: selectedOption?.listImage, detailImage: selectedOption?.detailImage }); // Optionally update formData as well
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={Boolean(errors?.subTraitName)}
                  helperText={errors?.subTraitName}
                  label="Sub Trait"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3} >
            <TextField value={formData.value} name="value" fullWidth label="Value" onChange={handleInputChange}
              error={Boolean(errors?.value)}
              helperText={errors?.value}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3} >
            <FormControl fullWidth>
              <InputLabel>Unit</InputLabel>
              <Select
                className="form-select"
                value={formData.unit || ''}
                name="unit"
                onChange={handleInputChange}
                displayEmpty
                fullWidth
                variant="outlined"
                label="Unit"
                renderValue={(selected) => selected}
                error={Boolean(errors?.unit)}
                helperText={errors?.unit}
              >
                                <MenuItem className="color-blue" onClick={handleAddNewUnitModal}>
                  + Add New Unit 
                </MenuItem>
                {unitList?.map((item, index) => (
                  <MenuItem key={index} value={item.unit}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
                      <Typography variant="body2" noWrap>{`${item.label} (${item.unit})`}</Typography>
                      <IconButton
                        className="remove-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault()
                          dispatch(openCustomModalDialog(
                            {
                              modalData: {
                                deleteHandler,
                                deleteId: item.unit,
                                deleteType: 'unit'
                              }, modal: 'DELETE_MODAL'
                            }))

                        }}
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          e.preventDefault()
                        }}  // Prevent the field from being focused when clicking the delete icon
                      >
                        <DeleteIcon />
                      </IconButton >
                    </Stack>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} className="d-flex mt-2 gap-2">
            <MDButton
              sx={{ minWidth: '160px' }}
              type='submit'
              variant='contained'
              color='primary'
              onClick={handleSave}
              loading={loadingProductTraits}
              disabled={loadingProductTraits}
            >
              Save
            </MDButton>
            <MDButton
              sx={{ minWidth: '160px' }}
              type='button'
              variant='outlined'
              color='dark'
              onClick={handleCancel}
            >
              Cancel
            </MDButton>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
